package navigation.settings.categories.allcategories

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.category.ui.allcategories.AllCategoriesEvent
import com.essntl.features.category.ui.allcategories.AllCategoriesState
import com.essntl.features.category.ui.allcategories.AllCategoriesViewModel

class AllCategoriesScreenModel(
    categoryRepository: CategoryRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllCategoriesState>(AllCategoriesState()) {

    private val viewModel =
        AllCategoriesViewModel(
            categoryRepository = categoryRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllCategoriesEvent) = viewModel.onEvent(event)
}